import { render, staticRenderFns } from "./PageConfirmEmail.vue?vue&type=template&id=23d7fda0"
import script from "./PageConfirmEmail.vue?vue&type=script&lang=ts"
export * from "./PageConfirmEmail.vue?vue&type=script&lang=ts"
import style0 from "./PageConfirmEmail.vue?vue&type=style&index=0&id=23d7fda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports